/**
 * ### Description
 *
 * This function checks a grid rule is not undefined and after a JSON.parse, isArray.
 */
export const isValidGridRule = (rule?: string) => {
  if (typeof rule === 'undefined') return false;
  // Try catch JSON.parse("") and unexpected end of JSON input
  try {
    const safeRule = JSON.parse(rule);
    if (Array.isArray(safeRule)) return true;
  } catch {
    /** No need to log here */
  }
  return false;
};
